module.exports = __webpack_public_path__ + "assets/img/section-4-landing-page-kid-left.7069aaff.png";